import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { BookingSubscriptionsPlan } from '@vi-iot/client';

import { AuthStore, BookingStore } from '@store';
import { ShepherdModalService } from '../../../shepherd/shepherd-modal.service';

@Component({
  selector: 'app-paid-features-banner',
  templateUrl: './paid-features-banner.component.html',
  styleUrls: ['./paid-features-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaidFeaturesBannerComponent implements OnInit, OnDestroy {
  bookingPlans: BookingSubscriptionsPlan[];

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public authStore: AuthStore,
    public bookingStore: BookingStore,
    public shepherdModalService: ShepherdModalService
  ) {}

  ngOnInit(): void {
    this.bookingStore.fetchSubscriptionsPlans();
  }

  getPrice(): Observable<{
    currency: string;
    price: number;
    basePrice?: number;
  }> {
    return this.bookingStore.subscriptionsPlans$.pipe(
      takeUntil(this.ngUnsubscribe$),
      map((plans) => plans?.pro?.price)
    );
  }

  close(): void {
    this.authStore.closePaidFeaturesBanner();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
